/* MADE IN countdown timer: Temu-style digit boxes.
   mode="daily"  -> counts down to the next local midnight, then restarts on its own (recurring).
   mode="fixed"  -> counts down to a fixed end_ms timestamp once, then hides the whole widget. */
(function () {
  'use strict';

  function nextMidnight() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0).getTime();
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function setNum(box, val) {
    if (!box) return;
    var el = box.querySelector('.mi-timer__num');
    if (!el) return;
    var next = pad(val);
    if (el.textContent === next) return;
    el.textContent = next;
    el.classList.remove('mi-timer__num--flip');
    // Restart the flip animation without forcing a synchronous layout reflow
    // (avoid reading offsetWidth; a double rAF lets the class removal paint first).
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('mi-timer__num--flip');
      });
    });
  }

  function tick(el, state) {
    var mode = el.getAttribute('data-mi-timer-mode');
    var target = state.target;
    var ms = target - Date.now();

    if (ms <= 0) {
      if (mode === 'daily') {
        state.target = nextMidnight();
        ms = state.target - Date.now();
      } else {
        el.hidden = true;
        return;
      }
    }

    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);

    setNum(el.querySelector('[data-mi-unit="d"]'), d);
    setNum(el.querySelector('[data-mi-unit="h"]'), h);
    setNum(el.querySelector('[data-mi-unit="m"]'), m);
    setNum(el.querySelector('[data-mi-unit="s"]'), s);

    var sr = el.querySelector('[data-mi-timer-sr]');
    if (sr) {
      var parts = [];
      if (d > 0) parts.push(d + ' يوم');
      parts.push(h + ' ساعة', m + ' دقيقة');
      sr.textContent = 'متبقٍ ' + parts.join(' و');
    }
  }

  var bound = new WeakMap();

  function scan() {
    document.querySelectorAll('[data-mi-timer]').forEach(function (el) {
      if (bound.has(el)) return;
      var mode = el.getAttribute('data-mi-timer-mode');
      var target;
      if (mode === 'daily') {
        target = nextMidnight();
      } else {
        target = parseInt(el.getAttribute('data-mi-timer-end'), 10);
        if (!target || isNaN(target) || target <= Date.now()) { el.hidden = true; return; }
      }
      var state = { target: target };
      bound.set(el, state);
      tick(el, state);
      var interval = setInterval(function () {
        if (!el.isConnected) { clearInterval(interval); bound.delete(el); return; }
        tick(el, state);
      }, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', scan, { once: true });
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
